/**
 *
 * Asynchronously loads the component for MemberListPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
